import React from 'react'
import UsersChartLine from './UsersChartLine'

export default function UsersChartLineAll() {
  return <UsersChartLine />
}
